import { __decorate, __metadata } from "tslib";
import { IsEnum, IsOptional, IsString, IsUrl } from 'class-validator';
import { ProducerConditionLevel } from './ProducerConditionLevel';
import { ProducerConditionType } from './ProducerConditionType';
export class ProducerCondition {
}
__decorate([
    IsEnum(ProducerConditionType),
    __metadata("design:type", String)
], ProducerCondition.prototype, "type", void 0);
__decorate([
    IsEnum(ProducerConditionLevel),
    __metadata("design:type", String)
], ProducerCondition.prototype, "level", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], ProducerCondition.prototype, "detail", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], ProducerCondition.prototype, "technicalDetail", void 0);
__decorate([
    IsUrl(),
    IsOptional(),
    __metadata("design:type", Object)
], ProducerCondition.prototype, "helpUrl", void 0);
